import { memo, ReactNode, useContext, useEffect, useMemo, useRef } from "react"

import './index.scss'
import { useHoverOutside } from "../../hooks/useHoverOutside"
import { useBounds } from "../../hooks/useBounds"
import TooltipContext from "../../contexts/TooltipContext/context"
import { hideTooltip, showTooltip } from "../../contexts/TooltipContext/actions"

type Tooltip = {
  content?: ReactNode | string
  text: string
}

const Tooltip = memo(({ content, text }: Tooltip) => {
  const { dispatch } = useContext(TooltipContext)

  const boundsRef = useRef<any | null>()

  const { ref, isHovered } = useHoverOutside<HTMLDivElement>()

  const { bounds } = useBounds(boundsRef)

  const styles = useMemo(() => {
    const styleObj = {}
    if (bounds) {
      if (bounds.x) styleObj.left = `${bounds.left - 12}px`

      if (bounds.top) styleObj.top = `${bounds.top - 40}px`
    }
    return styleObj
  }, [bounds])

  useEffect(() => {
    if (isHovered) dispatch(showTooltip({ text, style: styles }))
    else dispatch(hideTooltip())
  }, [isHovered])

  if (!text) return content

  return (
    <div
      ref={ref}
      className="Tooltip"
    >
      <div
        ref={boundsRef}
        className="Tooltip__content"
      >
        {content}
      </div>
    </div>
  )
})

export default Tooltip
